"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Label = require("./Label");
Object.keys(_Label).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Label[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Label[key];
    }
  });
});
var _LabelList = require("./LabelList");
Object.keys(_LabelList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LabelList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LabelList[key];
    }
  });
});
var _LabelPicker = require("./LabelPicker");
Object.keys(_LabelPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LabelPicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LabelPicker[key];
    }
  });
});